import { BaseRecord } from 'app/context/data/types';
import { Descriptions } from 'app/modules/ui';
import React from 'react';

type DefectsProps<T = BaseRecord> = {
  config: any[];
  value?: T[];
};

export const Defects = (props: DefectsProps) => {
  const { config, value } = props;

  return (
    <React.Fragment>
      {value.map((defect, key) => {
        return <Descriptions key={key} items={config} value={defect} />;
      })}
    </React.Fragment>
  );
};
